<!-- app.component.html -->
<file-pond #myPond
           [options]="pondOptions"
           [files]="pondFiles"
           (oninit)="pondHandleInit()"
           (onaddfile)="pondHandleAddFile($event)">
</file-pond>
